import React from 'react';
import { FadeIn } from './FadeIn';
import { CheckCircle2Icon } from 'lucide-react';
export function IncludesSection() {
  const items = [{
    title: '20 Recetas Legendarias',
    description: '10 Rústicos (Baguette, Pizza, Ciabatta, Pan de Papa...) y 10 Dulces (Conchas, Golfeados, Estrella de Nutella, Pan de Muerto...).'
  }, {
    title: 'Procedimiento Paso a Paso',
    description: 'Desde la activación de la levadura hasta el dorado perfecto en tu horno.'
  }, {
    title: 'Guía Visual de Cortes',
    description: 'Aprende cómo decorar tu pan para que parezca salido de una revista de panadería.'
  }, {
    title: 'Tiempos de Leudado Express',
    description: 'La tabla exacta para que tu pan doble su tamaño en tiempo récord sin perder sabor.'
  }];
  return <section className="bg-warm-gradient py-24 px-6 border-y border-bakery-amber/20" data-id="element-85">
      <div className="max-w-5xl mx-auto" data-id="element-86">
        <FadeIn className="text-center mb-16" data-id="element-87">
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-bakery-brown mb-4" data-id="element-88">
            ¿Qué incluye el manual?
          </h2>
          <div className="w-24 h-1 bg-bakery-amber mx-auto rounded-full" data-id="element-89"></div>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8" data-id="element-90">
          {items.map((item, index) => <FadeIn key={index} delay={index * 0.15} data-id="element-91">
              <div className="bg-bakery-cream/80 backdrop-blur-sm p-8 rounded-2xl flex items-start space-x-4 h-full shadow-sm border border-white/50" data-id="element-92">
                <CheckCircle2Icon className="w-8 h-8 text-bakery-amber flex-shrink-0 mt-1" data-id="element-93" />
                <div data-id="element-94">
                  <h3 className="text-xl font-bold text-bakery-brown mb-2" data-id="element-95">
                    {item.title}
                  </h3>
                  <p className="text-bakery-brown/70 leading-relaxed" data-id="element-96">
                    {item.description}
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}